export default __webpack_public_path__ + "static/media/partner.16e4c122.svg";